export function sanitizeVin(vin: string): string {
  return String(vin || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
}

export function isValidVin(vin: string): boolean {
  const sanitized = sanitizeVin(vin)
  const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/
  return vinRegex.test(sanitized)
}

